const stringsNL = {
  'general.loggingIn': 'Inloggen...',
  'general.invalidPassword': 'Het wachtwoord is ongeldig, probeer opnieuw',
  'general.goToLogin': 'Ga naar login',
  'general.loggedOutText': 'U bent uitgelogd',
  'general.changePassword': 'Wachtwoord wijzigen',
  'general.modified': 'Aangepast',
  'general.mobile': 'Mobiel',
  'general.desktop': 'Desktop',
  'general.backTo': 'Terug naar',
  'general.synced': 'Gesynchroniseerd',
  'general.assigned': 'toegewezen',
  'general.notAssigned': 'niet toegewezen',
  'menuLabel.notesAndDocuments': "Nota's en documenten",
  'plants.filterByTag': 'Filter per tag',
  'plants.recentlyModified': 'sorteer volgens laatst aangepast',
  'plants.plantName': 'sorteer volgens installatienaam',
  'newPlantDialog.insertGroup': '+ voeg een nieuwe groep toe en druk op Enter',
  'plantDetail.addDevice': 'Toestel toevoegen',
  'plantDetail.addObjects': 'Functie toevoegen',
  'plants.noPlantsHint':
    'Klik op de « Nieuwe installatie » toets om een nieuwe installatie aan te maken  ',
  'plantDetail.newUpdates': 'Nieuwe updates',
  'plantDetail.willRefreshToReflectChanges':
    'Dit element werd geupdatet. De pagina wordt vernieuwd om de aanpassingen te tonen.',
  'plantDetail.addGroup': 'Groep toevoegen',
  'plantDetail.addScene': 'Scenario toevoegen',
  'plantC300EOSSettings.GeneralSettings': 'Algemene instellingen',
  'plantC300EOSSettings.DoorEntryParametrs': 'DEURCOMMUNICATIE PARAMETERS',
  'plantC300EOSSettings.descPage':
    'Niet alle parameters kunnen vanuit deze sectie worden gewijzigd: u zult dit ter plaatse moeten doen met de aangesloten app',
  'general.favourites': 'Favorieten',
  'general.select': 'Selecteer',
  'general.operationError': 'Error',
  'plantDetail.lastScan': 'Laatste scan: {date} om {time}',
  'general.assignIcon': 'Icoon toewijzen',
  'general.assignedIcon': 'Toegewezen icoon',
  'newPlantDialog.modified': 'Installatie aangepast',
  'plantDetail.deletePlantConfirm':
    'Wil u {plantName} verwijderen? Alle data zal verloren gaan. Geef de code {code} om te verwijderen en bevestig',
  'plantDetail.objectsCreated': 'Objecten succesvol aangemaakt',
  'plantDetail.selectDevice': 'Selecteer een apparaat om zijn modules te zien',
  'plantDetail.typeNameGroup': 'Type en naam van de groep',
  'plantDetail.disableScene': "Scenario's deactiveren",
  'plantDetail.disableSceneConfirm':
    'Bent u zeker dat u scenario "{sceneName}" wil deactiveren?',
  'plantC300EOSSettings.SetAsPrimaryEntryUnitDESC':
    'De primaire binnenpost is de enige met antwoordapparaat en doorschakeling van de oproep naar Smartphone',
  'plantC300EOSSettings.ProfessionalStudioDESC':
    'Bij de instelling "automatisch deurslot" wordt het deurslot geopend telkens iemand aanbelt',
  'scenes.trigger': 'trigger',
  'uniqueNaming.validationError': 'De naam is ongeldig',
  'uniqueNaming.unavailableName': 'Onbeschikbare naam',
  'uniqueNaming.roomInlineNamingError': 'De naam kan niet geupdatet worden',
  'uniqueNaming.roomInlineNamingSuccess': 'Ruimtenaam geupdatet',
  'uniqueNaming.nameResetDisclaimer':
    'The naam wordt gereset naar de oorspronkelijke naam',
  'uniqueNaming.validationErrorWithSuggestion':
    'De naam is ongeldig, je kan proberen met: "{suggestedName}"',
  'plantsList.duplicateDialog.inputLabel':
    'Je kan de namen van de installaties hier aanpassen',
  'plantDialogDuplicate.howManyCopies': 'Hoeveel copies',
  'plantDialogDuplicate.success': 'Installatie gedupliceerd',
  'general.actuatorAdded': 'Actuator toegevoegd',
  'general.commandAdded': 'Bediening toegevoegd',
  isEditingPlant: 'is bezig met de configuratie aan te passen',
  eliotParseException:
    'Probleem met het lezen van de configuratie in de Cloud.', // assignObject: {
  //   selectFromLastScan: 'Select from last scan',
  //   selectFromCatalogue: 'Select from catalogue',
  // },
  // assignThermo: {
  //   selectOnlyOneDescription:
  //     'TEMP STRING You should select one and only one device.',
  //   thermostatAdded: 'Thermostat added',
  //   heatingActuatorAdded: 'Heating actuator added',
  //   coolingActuatorAdded: 'Cooling actuator added',
  //   sharedActuatorAdded: 'Shared actuator added',
  //   heatingPumpAdded: 'Heating pump added',
  //   coolingPumpAdded: 'Cooling pump added',
  //   sharedPumpAdded: 'Shared pump added',
  //   probeAdded: 'Probe added',
  // },
};
export default stringsNL;
